import React from 'react'
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import Modal from 'react-bootstrap/Modal';
import { Worker } from '@react-pdf-viewer/core';
import { Viewer } from '@react-pdf-viewer/core';
import Loader from '../../../../../../../../shared/Loader/Loader';

const PreviewImage = (props) => {

    const { modalActive, onClose, type, item, isLoading } = props
    const IMAGE_TYPES = ['image/png', 'image/jpeg', "image/tiff"];
    const defaultLayoutPluginInstance = defaultLayoutPlugin();
    console.log("typetypetype", type, IMAGE_TYPES)

    return (
        <Modal show={modalActive} onHide={() => onClose()} backdrop="static" keyboard={false} centered dialogClassName={`app-modal modal-md hk-login-v1 hk-modal-v1 ${IMAGE_TYPES.includes(type) ? 'ar_image_modal-new-changes' : ''} `}>
            <Modal.Body>
                <div className="download-header">
                    <div className='hide-me'></div>
                    <button className="btn-icon-transparent" onClick={() => onClose()}>
                        <i className="icon-x-cros fs-20 dark-clr"></i>
                    </button>
                </div>
                <div className="image-box">
                    {IMAGE_TYPES.includes(type)
                        ?
                        <div className="d-flex align-items-center justify-content-center">
                            <img src={item} alt='Image' className='mw-370px w-auto h-auto' />
                        </div> : null}
                </div>
                {isLoading ? <Loader /> : null}
            </Modal.Body>
            <div className='d-flex align-items-center pb-15 px-10 pt-2 br-top-1 za_br_light justify-content-end ar_footer'>
                <button className='btn btn-outline  px-10 h-100 dark-clr' onClick={() => onClose()}>Cancel</button>
            </div>
        </Modal>
    )
}

export default PreviewImage
